import { useQueryClient as t, useMutation as n } from "@tanstack/react-query";
import { a as s } from "./api.DHdhNbok.js";
import { saveTimestampToLocalStorage as r } from "../utils/storage/index.js";
const i = async () => {
  r();
  const e = await s.delete("api/accounts/connectedRelationshipSession");
  if (!e.ok)
    throw new Error(await e.json());
  return e.json();
}, m = (o) => {
  const e = t();
  return n({
    ...o,
    mutationFn: i,
    onSuccess: () => {
      e.resetQueries(), typeof window < "u" && (window.sessionStorage.removeItem("connectedRelId"), window.sessionStorage.removeItem("connectedRel"), window.localStorage.removeItem("mainUser"));
    }
  });
};
export {
  m as u
};
